import { notifications } from "@mantine/notifications"
import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from "@tanstack/react-query"

import { AdminResponses } from "@tfg/types/endpoints/admin"
import { LibraryResponses } from "@tfg/types/endpoints/library"
import { PaginationType } from "@tfg/types/schemas/utils"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useListTranslations = ({
  pagination,
  searchParams,
}: PaginationType) =>
  useQuery(["translations", [pagination, searchParams]], async () => {
    const res = await httpClient.get<AdminResponses.TranslationWithTotal>(
      "/admin/translations",
      {
        params: {
          pagination,
          searchParams,
        },
      }
    )
    return res.data
  })

export const useUpdateTranslationsMutation = (
  options?: UseMutationOptions<
    unknown,
    unknown,
    LibraryResponses.TranslationUpdate
  >
) => {
  return useMutation({
    ...options,
    mutationFn: async (variables) => {
      const response = await httpClient.post(
        "/admin/translations/update",
        variables
      )
      return response.data
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["translations"])
      notifications.show({
        title: "Added",
        message: "Successfully updated translation",
        color: "green",
      })
    },
  })
}
